module.exports = __webpack_public_path__ + "static/media/博士班_課程修習及學位考試規定_1100310.c464f7c3.pdf";